/**
 * Centralized polling interval configuration.
 *
 * Intervals are staggered to prevent thundering herd effect where
 * all queries fire simultaneously and exhaust the connection pool.
 *
 * @see https://linear.app/cova/issue/COV-151 - Connection pool exhaustion fix
 */
export const POLLING_INTERVALS = {
  /** Real-time critical: notifications, unread counts (30s) */
  REALTIME: 30_000,

  /** User-facing active data: team members, files, policies (60s) */
  ACTIVE: 60_000,

  /** Background data: contacts, dates, tasks (90s) */
  BACKGROUND: 90_000,

  /** Slow-changing data: dashboard metrics, recent chats (120s) */
  DASHBOARD: 120_000,

  /** File processing status when files are being extracted (10s) */
  FILE_PROCESSING: 10_000,

  /** Podcast library while an episode is processing (4s) */
  PODCAST_PROCESSING: 4_000,

  /** Team chat when panel is open (10s) */
  TEAM_CHAT_OPEN: 10_000,

  /** Agent preview panel head-check while a document is open (10s) */
  PREVIEW_SYNC: 10_000,
} as const

export type PollingIntervalKey = keyof typeof POLLING_INTERVALS
